function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React from 'react';
import t from 'prop-types';
import CartulinaCanvas from '../components/cartulina-canvas';

function Cartulina(_ref) {
  var activa = _ref.activa,
      props = _objectWithoutProperties(_ref, ['activa']);

  if (!activa) {
    return null;
  } // window.console.log('Cartulina', { props })


  return React.createElement(CartulinaCanvas, props);
}

Cartulina.propTypes = process.env.NODE_ENV !== "production" ? {
  activa: t.bool.isRequired
} : {};
export default Cartulina;